import { apiFinanceiroBancoGet } from "thirdParty/financeiro/api/apiFinanceiroBancoGet";
import type { ApiFinanceiroBanco } from "thirdParty/financeiro/types/ApiFinanceiroBanco";
import { useQuery } from "@tanstack/react-query";
import { Select } from "antd";
import { useMemo } from "react";

export function SelectFinanceiroBanco({
	value,
	onChange,
	disabled,
}: {
	value?: number | null;
	onChange?: (value: number | null, banco: ApiFinanceiroBanco | null) => void;
	disabled?: boolean;
}) {
	const { data, isFetching } = useQuery({
		queryKey: ["apiFinanceiroBancoGet"],
		queryFn: () => apiFinanceiroBancoGet(),
	});

	const options = useMemo(() => {
		if (!data) {
			return [];
		}

		return data.map((banco) => ({
			value: banco.fba_idpk,
			label: banco.fba_nome,
		}));
	}, [data]);

	const handleChange = (value: number | null) => {
		if (value) {
			onChange?.(value, data?.find((banco) => banco.fba_idpk === value) || null);
		} else {
			onChange?.(null, null);
		}
	};

	return (
		<Select
			allowClear={true}
			value={value}
			disabled={disabled}
			loading={isFetching}
			options={options}
			className="w-full"
			placeholder="Instituição financeira"
			onChange={handleChange}
		/>
	);
}
